/*
 * Copyright (c) 2019  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";

import {
  FacebookShareButton,
  FacebookIcon,
  PinterestShareButton,
  PinterestIcon,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
  EmailShareButton,
  EmailIcon,
} from "react-share";

import landingPageStyle from "assets/jss/views/landingPage/landingPageStyle";
const useStyles = makeStyles(landingPageStyle);

const SocialShare = function (props: any) {
  const classes = useStyles();
  const { shareUrl, title, body } = props;
  const media = "https://apricad.com/mx/cover.jpg";

  return (
    <div
      className={classes.shareContainer}
      onClick={(e) => {
        e.preventDefault();
      }}>
      <div className={classes.shareItem}>
        <FacebookShareButton
          url={shareUrl}
          quote={title}
          hashtag="#ApricadCoursesOfNursing"
          className={classes.shareButton}>
          <FacebookIcon size={32} round />
        </FacebookShareButton>
      </div>

      <div className={classes.shareItem}>
        <PinterestShareButton
          url={shareUrl}
          media={media}
          windowWidth={1000}
          windowHeight={730}
          className={classes.shareButton}>
          <PinterestIcon size={32} round />
        </PinterestShareButton>
      </div>

      <div className={classes.shareItem}>
        <TwitterShareButton
          url={shareUrl}
          title={title}
          className={classes.shareButton}>
          <TwitterIcon size={32} round />
        </TwitterShareButton>
      </div>

      <div className={classes.shareItem}>
        <LinkedinShareButton
          url={shareUrl}
          title={title}
          windowWidth={750}
          windowHeight={600}
          className={classes.shareButton}>
          <LinkedinIcon size={32} round />
        </LinkedinShareButton>
      </div>

      <div className={classes.shareItem}>
        <EmailShareButton
          url={shareUrl}
          subject={title}
          body={body}
          separator={" --- "}
          className={classes.shareButton}>
          <EmailIcon size={32} round />
        </EmailShareButton>
      </div>
    </div>
  );
};

export default SocialShare;
